import React from "react";
import pkg from "@base/package.json";
import { Layout, Menu, Dropdown, Avatar } from "antd";
import { Link } from "react-router-dom";
import { useAuth } from "@contexts";
import {
  ShopOutlined,
  TeamOutlined,
  UserOutlined,
  ReadOutlined,
  LogoutOutlined,
  DashboardOutlined,
  SettingOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";

const { Header, Content, Footer, Sider } = Layout;

export default function Moderator({ children, page, ...props }) {
  const { currentUser } = useAuth();

  return (
    <Layout hasSider={false} style={{ minHeight: "100vh" }}>
      <Header
        className="bg-white shadow-sm flex justify-between items-center p-5 z-50"
        style={{
          height: 70,
          position: "fixed",
          // top: 0,
          zIndex: 1,
          width: "100%",
        }}
      >
        <div className="flex justify-start items-center">
          <img
            src="/img/logo-compact.png"
            className="block"
            height={40}
            alt="skviticultores.com"
          />
        </div>
        <Dropdown
          menu={{
            className: "min-w-44 max-w-xs",
            items: [
              {
                key: "profile",
                type: "group",
                label: (
                  <div className="w-full p-0">
                    <span className="break-words block mb-1 w-full text-neutral-400 font-normal text-xs">
                      ID {currentUser.id} &middot; {currentUser.email}
                    </span>
                  </div>
                ),
              },
              {
                key: "divider",
                type: "divider",
              },
              {
                key: "logout",
                icon: <LogoutOutlined />,
                label: (
                  <Link className="transition-none" to="/logout">
                    Logout
                  </Link>
                ),
                danger: true,
              },
            ],
          }}
        >
          <div className="flex items-center">
            <Avatar
              style={{ cursor: "pointer" }}
              icon={<UserOutlined />}
              size="large"
            />
            <div className="flex flex-col justify-center items-start ml-3 text-left cursor-pointer">
              <span className="text-base font-medium text-slate-900 leading-none m-0">
                {currentUser?.name}
              </span>
              <span className="text-sm text-neutral-400 leading-none mt-1">
                Admin
              </span>
            </div>
          </div>
        </Dropdown>
      </Header>
      <Layout
        hasSider={false}
        className="ml-16 lg:ml-52"
        style={{
          marginTop: 70,
          backgroundColor: "#fafafb",
        }}
      >
        <Sider
          className="bg-white pt-5"
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            bottom: 0,
          }}
          breakpoint="lg"
          collapsedWidth="64"
          width={208}
        >
          <div
            style={{
              height: 32,
              margin: 16,
            }}
          />
          <Menu
            mode="inline"
            selectedKeys={[page]}
            defaultOpenKeys={["dict", "blog"]}
            items={[
              {
                key: "dashboard",
                icon: <DashboardOutlined />,
                label: (
                  <Link className="transition-none" to="/">
                    Analytics
                  </Link>
                ),
              },
              {
                key: "orders",
                icon: <ShoppingCartOutlined />,
                label: (
                  <Link className="transition-none" to="/orders">
                    Orders
                  </Link>
                ),
              },
              {
                key: "dict",
                icon: <ShopOutlined />,
                label: "Wine Products",
                children: [
                  {
                    key: "products",
                    label: (
                      <Link className="transition-none" to="/products">
                        All Products
                      </Link>
                    ),
                  },
                  {
                    key: "projects",
                    label: (
                      <Link className="transition-none" to="/projects">
                        Projects
                      </Link>
                    ),
                  },
                  {
                    key: "countries",
                    label: (
                      <Link className="transition-none" to="/countries">
                        Countries
                      </Link>
                    ),
                  },
                  {
                    key: "regions",
                    label: (
                      <Link className="transition-none" to="/regions">
                        Regions
                      </Link>
                    ),
                  },
                  {
                    key: "producers",
                    label: (
                      <Link className="transition-none" to="/producers">
                        Wine Producers
                      </Link>
                    ),
                  },
                  {
                    key: "sweetnesses",
                    label: (
                      <Link className="transition-none" to="/sweetnesses">
                        Wine Types
                      </Link>
                    ),
                  },
                  {
                    key: "colors",
                    label: (
                      <Link className="transition-none" to="/colors">
                        Wine Colors
                      </Link>
                    ),
                  },
                  {
                    key: "varieties",
                    label: (
                      <Link className="transition-none" to="/varieties">
                        Wine Varieties
                      </Link>
                    ),
                  },
                ],
              },
              {
                key: "blog",
                icon: <ReadOutlined />,
                label: "Blog Articles",
                children: [
                  {
                    key: "articles",
                    label: (
                      <Link className="transition-none" to="/articles">
                        Articles
                      </Link>
                    ),
                  },
                  {
                    key: "article_categories",
                    label: (
                      <Link
                        className="transition-none"
                        to="/article_categories"
                      >
                        Categories
                      </Link>
                    ),
                  },
                  {
                    key: "tags",
                    label: (
                      <Link className="transition-none" to="/tags">
                        Tags
                      </Link>
                    ),
                  },
                ],
              },
              {
                key: "settings",
                icon: <SettingOutlined />,
                label: "Site Settings",
                children: [
                  {
                    key: "page-global",
                    label: (
                      <Link className="transition-none" to="/settings/global">
                        Global
                      </Link>
                    ),
                  },
                  {
                    key: "page-homepage",
                    label: (
                      <Link className="transition-none" to="/settings/homepage">
                        Homepage
                      </Link>
                    ),
                  },
                  {
                    key: "page-wines",
                    label: (
                      <Link className="transition-none" to="/settings/wines">
                        Wines
                      </Link>
                    ),
                  },
                  {
                    key: "page-blog",
                    label: (
                      <Link className="transition-none" to="/settings/blog">
                        Blog
                      </Link>
                    ),
                  },
                  {
                    key: "page-contacts",
                    label: (
                      <Link className="transition-none" to="/settings/contacts">
                        Contact Us
                      </Link>
                    ),
                  },
                  {
                    key: "page-delivery",
                    label: (
                      <Link className="transition-none" to="/settings/delivery">
                        Delivery
                      </Link>
                    ),
                  },
                  {
                    key: "page-about",
                    label: (
                      <Link className="transition-none" to="/settings/about">
                        About Us
                      </Link>
                    ),
                  },
                ],
              },
              {
                key: "users",
                icon: <TeamOutlined />,
                label: (
                  <Link className="transition-none" to="/users">
                    Users
                  </Link>
                ),
              },
            ]}
          />
        </Sider>
        <Content
          style={{
            margin: "24px 16px 0",
            overflow: "initial",
          }}
        >
          <div className="bg-none p-0 md:lg-p-3 lg:p-6">{children}</div>
        </Content>
        <Footer
          style={{
            backgroundColor: "#fafafb",
            textAlign: "center",
          }}
        >
          SKViticultores © {new Date().getFullYear()} | Powered by{" "}
          <a href="https://pure.kz/en" target="_blank">
            PURE
          </a>{" "}
          | Version {pkg.version}
        </Footer>
      </Layout>
    </Layout>
  );
}
